"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
function default_1(props) {
    return react_1.default.createElement(core_1.SvgIcon, __assign({}, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M15 0H3C1.343 0 0 1.343 0 3v12c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3V3c0-1.657-1.343-3-3-3zm-2.29 7.669l-4.08 4.08c-.188.19-.444.296-.71.296-.267 0-.523-.106-.71-.296l-1.92-1.92c-.393-.392-.393-1.027 0-1.419.392-.393 1.027-.393 1.42 0l1.21 1.219 3.37-3.38c.392-.392 1.028-.392 1.42 0 .392.392.392 1.028 0 1.42z" })));
}
exports.default = default_1;
